<template>
{{gradient}}
  <linearGradient
    v-if="type === 'linear'"
    :id="id"
     x1="0%" y1="0%" x2="100%" y2="0%"
    :gradientTransform="`rotate(${rotate},0.5,0.5)`"
  >
    <stop v-for="(r,i) in [...g].sort((a, b) => a.p - b.p)" :key="i" :offset="r.p + '%'" :stop-color="tinycolor(r.c)" />
  </linearGradient>
 
  <radialGradient :id="id"  :cx="postion?.split(',')[0] + '%'" :cy="postion?.split(',')[1] + '%'" v-else>
    <stop v-for="(r,i) in [...g].sort((a, b) => a.p - b.p)" :key="i" :offset="r.p + '%'" :stop-color="tinycolor(r.c)" />
  </radialGradient>
</template>

<script lang="ts">
import { computed, defineComponent, PropType} from 'vue'
import tinycolor from 'tinycolor2'
export default defineComponent({
  name: 'gradient-defs',
  props: {
    id: {
      type: String,
      required: true,
    },
    type: {
      type: String as PropType<'linear' | 'radial'>,
    },
    gradient: {
      type: Array
    },
    rotate: {
      type: Number,
      default: 90,
    },
    color: {
      type: Array,
    },
    postion: {
      type: String,
    },
  },
  setup(props) {
    const g = computed(() => {
      let gs = props.gradient || []
      const p: any[] = [0,100]
      if (props.gradient && props.gradient.length <= 0) {
        props.color?.forEach((c: any,ind: any) => {
          p?.forEach((p: any,index: any) => {
            if (ind !== index) return
            gs.push({
              c: c,
              p: p
            })
          })
        })
      }
      else {
        gs = props.gradient || []
      }
      return gs
    })
    
    return {
      g,
      tinycolor
    }
  }
})

</script>